import { FC } from 'react';
import i18next from 'i18next';

const getClientLang = (): string => {
  try {
    return localStorage.getItem('i18nextLng') || 'vi-VN';
  } catch (_) {
    return 'vi-VN';
  }
};

const LanguageSwitcher: FC = () => {
  const current = i18next.language || getClientLang();
  const isVi = current.startsWith('vi');

  const toggle = () => {
    const next = isVi ? 'en-US' : 'vi-VN';
    i18next.changeLanguage(next);
    try { localStorage.setItem('i18nextLng', next); } catch (_) { /* noop */ }
    window.location.reload();
  };

  return (
    <button type="button" className="lang-switcher-btn" onClick={toggle}>
      {isVi ? 'EN' : 'VI'}
    </button>
  );
};

export default LanguageSwitcher;
